import IsNextYearEarlyRegistrationContext from '@/contexts/IsNextYearEarlyRegistrationContext';
import { useGet } from '@ngt/forms';
import { useContext, useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetAdditionalPackageSessions, GetAdditionalPackageSessionsResponse } from '../api/dtos';

const getData = (response?: SWRResponse<GetAdditionalPackageSessionsResponse, GetAdditionalPackageSessionsResponse>) => response?.data?.sessions;

const getError = (response?: SWRResponse<GetAdditionalPackageSessionsResponse, GetAdditionalPackageSessionsResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetAdditionalPackageSessionsResponse, GetAdditionalPackageSessionsResponse>) => ({
    additionalSessions: response?.data?.sessions
});

export const useAdditionalSessions = (id?: number, isAdmin?: boolean, isSpeaker?: boolean, isTAndECSpeaker?: boolean, code?: string, voucherId?: number, configuration?: SWRConfiguration ) => {
    const isNextYearEarlyRegistration = useContext(IsNextYearEarlyRegistrationContext);
    const request = useMemo(() => {
    
        if (isNextYearEarlyRegistration) {
            return; // No additional sessions for next-year early registrations.
        }

        return () => {
            return new GetAdditionalPackageSessions({id: id, isAdminSection: isAdmin, isSpeaker, isTAndECSpeaker, code, voucherId});
        };

    }, [id, isAdmin, isSpeaker, isTAndECSpeaker, isNextYearEarlyRegistration, code, voucherId])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useAdditionalSessions;